import { createSlice } from "@reduxjs/toolkit";
import {
  deleteVideo,
  getVideo,
  getVideoCategory,
  undoDeleteVideo,
} from "./Video.api";

const photogallerySlice = createSlice({
  name: "video",
  initialState: {
    video: [],
    videoCategory: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    // GET Banner FILTER WISE DATA
    builder.addCase(getVideo.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getVideo.fulfilled, (state, action) => {
      state.loading = false;
      state.video = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getVideo.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(getVideoCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getVideoCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.videoCategory = action.payload;
    });
    builder.addCase(getVideoCategory.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteVideo.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteVideo.fulfilled, (state, action) => {
      const deletedId = action?.payload?.data?._id;
      if (state.video.data) {
        state.video.data = state.video.data.filter((video) => {
          return video._id !== deletedId;
        });
        state.loading = false;
      } else {
        console.error("state.video.data is not an array:", state.video.data);
      }
      state.loading = false;
    });
    builder.addCase(deleteVideo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteVideo.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteVideo.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.video.data) {
        state.video.data = state.video.data.filter((video) => {
          return video._id !== undodeletedId;
        });
        state.loading = false;
      } else {
        console.error("state.video.data is not an array:", state.video.data);
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteVideo.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = photogallerySlice.actions;
export default photogallerySlice.reducer;
